module.exports = __webpack_public_path__ + "static/media/f_faceshape_square_vector.894b7972.svg";